import { combineReducers } from 'redux';
import { all, race, call, take, fork } from 'redux-saga/effects';
import { createBrowserHistory } from 'history';
import { connectRouter } from 'connected-react-router';
import { CollectionsReducersEntries, Collections, CollectionsSagas, Collection } from './types';
import { autoRestart } from '../../utils/sagas';
// Collections
import modals from './modals';
import currentBooking from './currentBooking';
import pendings from './pendings';
import currentGroup from './currentGroup';
import currentPolicy from './currentPolicy';
import selfService from './selfService';
import user from './user';
import admin from './admin';
import ridesSoon from './ridesSoon';

const collections: Collections = {
    modals,
    currentBooking,
    pendings,
    currentGroup,
    currentPolicy,
    selfService,
    user,
    admin,
    ridesSoon,
};

// ActionTypes
export const types = {
    CLEAR_STATE: 'root/CLEAR_STATE',
};

// ActionCreators
export const actions = {
    clearState: (): any => ({ type: types.CLEAR_STATE }),
};

export const history = createBrowserHistory();

const collectionsReducers: CollectionsReducersEntries = Object.keys(collections)
    .map((key) => collections[key])
    .reduce(
        (reducersEntries, collection: Collection) =>
            collection.reducer
                ? {
                      ...reducersEntries,
                      [collection.name]: collection.reducer,
                  }
                : reducersEntries,
        {},
    );

const collectionsSagas: CollectionsSagas = Object.keys(collections)
    .map((key) => collections[key])
    .reduce(
        (sagas, collection) => (collection.saga ? [...sagas, autoRestart(collection.saga, collection.name, 2)] : sagas),
        [],
    );

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createRootReducer = () => {
    const combinedReducer = combineReducers({
        router: connectRouter(history),
        ...collectionsReducers,
    });

    const rootReducer = (state: any, action: any) => {
        if (action.type === types.CLEAR_STATE) {
            // eslint-disable-next-line no-param-reassign
            state = {};
        }
        return combinedReducer(state, action);
    };

    return rootReducer;
};

const forkedCollectionsSagas = collectionsSagas.map((saga) => fork(saga));
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function* rootSaga() {
    while (true) {
        yield race({
            sagas: call(function* forkAllSagas() {
                yield all(forkedCollectionsSagas);
            }),
            clear: take(types.CLEAR_STATE),
        });
    }
}

export { createRootReducer, rootSaga };
export default collections;
